<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-error-dialog-docs-preview></ui-error-dialog-docs-preview></p>
<h1 id="description">Description</h1>
<p>Generic dialog that could contain any html. Easiest way to use this is just to inline this in your html. To create a new custom dialog component. Have a look in how alert-dialog and confirm-dialogs is built.</p>
<h1 id="usage">Usage</h1>
<pre><code class="language-typescript"><span class="hljs-keyword">constructor</span>(<span class="hljs-params"><span class="hljs-keyword">private</span> errorDialogService: UIErrorDialogService</span>) {{ '{' }}{{ '}' }}

<span class="hljs-keyword">async</span> showError() {{ '{' }}
    <span class="hljs-keyword">await</span> <span class="hljs-keyword">this</span>.alertDialogService.show({{ '{' }}
        headerText: <span class="hljs-string">'This is a warning'</span>,
        text: <span class="hljs-string">'Important messsage'</span>,
        confirmText: <span class="hljs-string">'I accept'</span>
    {{ '}' }});
    <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'ok'</span>);
{{ '}' }}</code></pre>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-button</span>
    <span class="hljs-attr">text</span>=<span class="hljs-string">"Open dialog"</span>
    (<span class="hljs-attr">click</span>)=<span class="hljs-string">"showError()"</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-button</span>&gt;</span></code></pre>
